export default function NoIcon() {
  return (
    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2.00048" cy="1.99902" r="1.31249" fill="url(#paint0_linear_2406_2360)" stroke="#4A4A4A" stroke-width="0.374998" />
      <defs>
        <linearGradient id="paint0_linear_2406_2360" x1="0.730844" y1="0.630273" x2="3.17381" y2="3.00816" gradientUnits="userSpaceOnUse">
          <stop stop-color="#292929" />
          <stop offset="1" stop-color="#484848" />
        </linearGradient>
      </defs>
    </svg>
  );
}
